import { useSelector, useDispatch } from "react-redux";
export var useAppSelector = useSelector;
/**
 * @returns the redux dispatch for the root reducer
 */
export var useAppDispatch = function () { return useDispatch(); };
